export default __webpack_public_path__ + "static/footer-background-2e4b57339669e53784aa3140fb5adf2d.webp";